import { CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES } from "shared/types/enums";

export const FILE_TYPE_OPTIONS = [
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.MainConfigurationSync,
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.OneWireAuthListSync,
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.BluetoothAuthListSync,
    CONFIGURATION_FEATURE_SETTINGS_FILE_TYPES.ManualGeofenceListSync
];
